import { checkAndExecute, checkAndExecuteToActionReport } from 'root/api/helpers';

export default function HotelRfpBidAPI(api) {
  api.negotiations = {
    get: bidId => checkAndExecute(
      () => bidId,
      () => api.server.get(`rfps/bids/${bidId}/negotiations`)
    ),

    getHistory: (bidId, questionsIds) => checkAndExecute(
      () => bidId && questionsIds && questionsIds.length,
      () => api.server.get(`rfps/bids/${bidId}/negotiations/history`, {questions: questionsIds})
    ),

    add: (bidId, negotiation) => checkAndExecuteToActionReport(
      () => bidId && negotiation,
      () => api.server.post(`rfps/bids/${bidId}/negotiations`, negotiation)
    ),

    finalize: (bidId, negotiation) => checkAndExecuteToActionReport(
      () => bidId && negotiation,
      () => api.server.post(`rfps/bids/${bidId}/negotiations/finalize`, negotiation)
    ),

    resendRequest: bidId => checkAndExecuteToActionReport(
      () => bidId,
      () => api.server.post(`rfps/bids/${bidId}/negotiations/request/resend`)
    ),

    exportAllRounds: (bidId, filename) => checkAndExecute(
      () => bidId && filename,
      () => api.server.postAndAutoSaveFile(`rfps/bids/${bidId}/negotiations/export`, {filename})
    )
  };
}
